export function replaceImgSrcWithProxy(src = '', proxyDomain) {
    const replacementSrcPart = `https://${proxyDomain}/get-text-chat-image/`;
    const pattern = /https?:\/\//;
    return src.replace(pattern, replacementSrcPart);
}